<template>
  <v-app id="app-container">
    <v-app-bar :clipped-left="drawer.clipped" app>
      <v-btn
        icon
        :to="backTo"
        exact
        v-if="!!backTo && ($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly)"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-app-bar-nav-icon
        v-show="drawer.type !== 'permanent' && !(!!backTo && ($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly))"
        @click.stop="drawer.model = !drawer.model"
      ></v-app-bar-nav-icon>

      <!-- <v-select
        class="mt-4 ml-2 mr-4"
        :items="tahun.data"
        :loading="tahunLoading"
        :disabled="itemTahunEmpty"
        item-text="Tahun"
        item-value="Tahun"
        placeholder="Tahun"
        v-if="visibility"
        :value="activeTahun"
        @input="setTahun"
      ></v-select>
      <v-select
        class="mt-4"
        :items="status.data"
        :loading="statusLoading"
        :disabled="itemStatusEmpty"
        item-text="StatusAnggaran"
        item-value="StatusAnggaran"
        placeholder="Status"
        v-if="visibility"
        :value="activeStatus"
        @input="setStatus"
      ></v-select>-->
      <div class="hidden-sm-and-up teal-da" v-text="title()"></div>

      <v-spacer />
      <v-menu offset-y min-width="150">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-avatar>
              <v-icon large>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense max-width="250px">
          <v-list-item>
            <!-- <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>-->

            <v-list-item-content class="text-center">
              <v-list-item-title>{{user.name}}</v-list-item-title>
              <v-list-item-subtitle>
                {{user.group}} —
                <span class="caption">{{$format.dateRelative(user.lastLogin)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider />

          <v-list-item @click="toggleMode">
            <v-list-item-icon>
              <v-icon v-if="!$vuetify.theme.dark">mdi-weather-night</v-icon>
              <v-icon v-else>mdi-weather-sunny</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <strong v-text="'Mode '+(!$vuetify.theme.dark ?'gelap':'terang')"></strong>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider />

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Keluar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <drawer />

    <v-content>
      <v-container fluid class="px-6">
        <v-row v-if="!($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly)">
          <v-col cols="12">
            <v-list-item class="ml-n3">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  fab
                  dark
                  small
                  :color="(!backTo)?'cyan':(hover?'cyan':'grey')"
                  :to="backTo || ''"
                >
                  <v-icon v-text="!backTo? icon() : 'mdi-arrow-left'"></v-icon>
                </v-btn>
              </v-hover>
              <v-list-item-content class="py-0 ml-2">
                <v-list-item-title class="text-uppercase text--secondary">{{title()}}</v-list-item-title>
                <v-list-item-subtitle class="text--disabled">
                  {{subtitle()}}
                  <v-breadcrumbs :items="breadcrumbs" class="px-2 py-0 float-right">
                    <template v-slot:divider>
                      <v-icon>mdi-chevron-right</v-icon>
                    </template>
                  </v-breadcrumbs>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-divider v-if="!($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly)" />
        <v-row>
          <v-col cols="12">
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <v-footer :inset="true" app>
      <v-spacer />
    </v-footer>
  </v-app>
</template>

<style lang="scss" scoped>
#app-container {
  &.theme--light {
    background: #fafafa;
  }

  .content-title {
    text-align: right;
    @media screen and (max-width: 600px) {
      text-align: left;
    }
  }
}
</style>

<style lang="scss">
.w-100 {
  width: 100% !important;
}
.w-95 {
  width: 95% !important;
}
.card-summary {
  height: 106px !important;
}
.v-hidden {
  visibility: hidden;
}

.v-toolbar--grid {
  .v-toolbar__content {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}

.v-card__subtitle {
  & > .v-btn.v-btn--icon {
    margin: -12px -12px -8px auto !important;
  }
}

.v-dialog {
  & .v-card {
    & .v-card__text {
      &.dialog-form {
        padding-bottom: 12px !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
        padding-top: 12px !important;
      }
    }
  }
}
.dialog-form .v-toolbar--grid {
  .v-toolbar__content {
    padding-left: 0px !important;
    padding-right: 0px !important;

    & > .v-btn {
      min-height: 48px !important;
    }
  }
  margin-bottom: 5px;
}

.v-skeleton-loader {
  // .v-skeleton-loader__bone {
  //   // padding-left: 0;
  // }
  &.actions__left {
    .v-skeleton-loader__actions {
      text-align: left !important;
    }
  }
}
</style>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data: () => ({
    right: null,
    routes: [],
    header: {
      tahun: Number,
      status: String
    }
  }),
  computed: {
    ...mapState({
      drawer: state => state.layout.drawer,
      layoutRoutes: state => state.layout.routes,
      breadcrumbs: function() {
        return this.$route.meta.breadcrumbs;
      },
      backTo: function() {
        return this.$route.meta.back;
      }
    }),
    ...mapState("status", ["tahun", "status", "visibility"]),
    ...mapGetters("status", [
      "tahunLoading",
      "statusLoading",
      "itemTahunEmpty",
      "itemStatusEmpty",
      "activeStatus",
      "activeTahun"
    ]),
    user() {
      let user = this.$session.get.user();
      return user;
    }
  },
  components: {
    Drawer: () =>
      import(/* webpackChunkName: "app-drawer" */ "@/components/Drawer.vue")
  },
  methods: {
    currentLayoutRoute() {
      return (
        this.routes.find(
          r => this.$route.path.indexOf(r.path) > -1 && r.path != "/"
        ) || {}
      );
    },
    title() {
      let route = this.currentLayoutRoute();
      return route.name || "";
    },
    subtitle() {
      let route = this.currentLayoutRoute();
      return route.subname || "";
    },
    icon() {
      let route = this.currentLayoutRoute();
      return route.icon || "mdi-cube-outline";
    },
    toggleMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark", this.$vuetify.theme.dark);
    },
    async logout() {
      this.$session.clear();
      localStorage.setItem("dark", this.$vuetify.theme.dark);
      this.$acl.change("public");
      this.$router.push("/login");
    }
  },
  beforeCreate() {
    var dark = localStorage.getItem("dark");
    this.$vuetify.theme.dark = dark ? dark == "true" : false;
  },
  created() {},
  mounted() {
    this.routes = this.layoutRoutes.reduce((flatRoutes, route) => {
      flatRoutes = flatRoutes || [];
      if ("childs" in route) {
        let childs = route.childs || [];
        childs.forEach(child => {
          flatRoutes.push(Object.assign({ subname: route.name }, child));
        });
      } else {
        flatRoutes.push(Object.assign({ subname: "Main" }, route));
      }

      return flatRoutes || [];
    }, []);
  },
  watch: {}
};
</script>